import { gql } from "@apollo/client";
import { AGENT_TASK_FIELDS } from "./agentTask";

const CORE_MISSION_ROLE_TEMPLATE_FIELDS = gql`
  ${AGENT_TASK_FIELDS}
  fragment MissionRoleTemplateFields on MissionRoleTemplate {
    id
    uuid
    slug
    name
    state
    assessmentId
    disciplines {
      id
      name
    }
    primarySkills {
      id
      name
    }
    interview {
      uuid
    }
    missionRoleChallenges {
      id
    }
    requirementsCount
    questionsCount
    interviewQuestionsCount
    challengesCount
    latestBlueprintGenerationAgentTask {
      ...AgentTaskFields
    }
    createdAt
    updatedAt
  }
`;

const MISSION_ROLE_TEMPLATE_VETTING_FIELDS = gql`
  fragment MissionRoleTemplateVettingFields on MissionRoleTemplate {
    id
    uuid
    slug
    name
    state
    assessmentId
    disciplines {
      id
      name
    }
    primarySkills {
      id
      name
    }
    requirementsLocked
    roleRequirementsQuestion {
      id
    }
    requirements {
      id
      description
      originalValue
    }
    availableRequirements {
      id
      value
      originalValue
    }
    challenges {
      id
      name
    }
    missionRoleChallenges {
      id
      enabled
      responsesCount
      challenge {
        id
        name
      }
    }
    interview {
      uuid
    }
  }
`;

export { CORE_MISSION_ROLE_TEMPLATE_FIELDS, MISSION_ROLE_TEMPLATE_VETTING_FIELDS };
